import DataService from "@/services/DataService";

export default {
  getRID() {
    return DataService.apiClient.get("/customer/createRID");
  },
  getLieferortID() {
    return DataService.apiClient.get("/customer/createLieferortID");
  },
  getAll() {
    return DataService.apiClient.get("/customer");
  },

  get(id) {
    return DataService.apiClient.get("/customer/" + id);
  },
  findByName(name) {
    return DataService.apiClient.get("/customer/findbyname/" + name);
  },

  getLastItem() {
    return DataService.apiClient.get("/customer/last/");
  },
  save(item) {
    //console.log(item);
    if (item.id != null) {
      return DataService.apiClient.patch(
        "/customer/edit/" + item.id,
        item.data
      );
    } else {
      return DataService.apiClient.post("/customer/add", item.data);
    }
  },
  delete(id) {
    return DataService.apiClient.delete("/customer/delete/" + id);
  },
  removeLogo(id) {
    return DataService.apiClient.delete("/customer/image/" + id);
  },
};
